import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d07138e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CreateFtl" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ftl_excel_multiple_modal = _resolveComponent("ftl-excel-multiple-modal")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_step_company = _resolveComponent("step-company")!
  const _component_step_date_ftl_create = _resolveComponent("step-date-ftl-create")!
  const _component_step_cargo_ftl_create = _resolveComponent("step-cargo-ftl-create")!
  const _component_step_car_ftl_create = _resolveComponent("step-car-ftl-create")!
  const _component_step_waypoints = _resolveComponent("step-waypoints")!
  const _component_step_create = _resolveComponent("step-create")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.excel_multiple_state.is_opened)
      ? (_openBlock(), _createBlock(_component_ftl_excel_multiple_modal, {
          key: 0,
          "company-id": _ctx.state.company_id,
          onCancel: _ctx.closeExcelMultipleModal,
          onOrderCreated: _ctx.onExcelMultipleOrderCreated
        }, null, 8, ["company-id", "onCancel", "onOrderCreated"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Создание FTL заказа" }),
      _createVNode(_component_the_button, {
        class: "second text small",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Назад ")
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_step_company, {
      class: "mt-6",
      "step-number": 1,
      disabled: _ctx.state.is_creating_ftl_bid || _ctx.state.is_ftl_created,
      "company-id": _ctx.state.company_id,
      onSubmit: _ctx.onCompanySubmit,
      onReset: _ctx.onCompanyReset
    }, null, 8, ["disabled", "company-id", "onSubmit", "onReset"]),
    _createVNode(_component_step_date_ftl_create, {
      class: "mt-6",
      "step-number": 2,
      opened: _ctx.isCompanySelected,
      disabled: _ctx.state.is_creating_ftl_bid || _ctx.state.is_ftl_created,
      onSubmit: _ctx.onDateSubmit,
      onReset: _ctx.onDateReset,
      onExcelMultipleOrder: _ctx.openExcelMultipleModal
    }, null, 8, ["opened", "disabled", "onSubmit", "onReset", "onExcelMultipleOrder"]),
    _createVNode(_component_step_cargo_ftl_create, {
      class: "mt-6",
      "step-number": 3,
      opened: _ctx.isDateSelected,
      "is-update": _ctx.state.is_updating_cargo,
      "updating-cargo": _ctx.state.updating_cargo,
      disabled: _ctx.state.is_creating_ftl_bid || _ctx.state.is_ftl_created,
      "ftl-type": _ctx.state.ftl_type,
      "is-completed": _ctx.state.is_step_cargo_finished,
      onSubmit: _ctx.onCargoSubmit,
      onCancelUpdate: _ctx.cancelUpdateCargo,
      onStartUpdateCargo: _ctx.onStartUpdateCargo
    }, null, 8, ["opened", "is-update", "updating-cargo", "disabled", "ftl-type", "is-completed", "onSubmit", "onCancelUpdate", "onStartUpdateCargo"]),
    _createVNode(_component_step_car_ftl_create, {
      class: "mt-6",
      "step-number": 4,
      opened: _ctx.state.is_on_step_car,
      "ftl-type": _ctx.state.ftl_type,
      disabled: _ctx.state.is_creating_ftl_bid || _ctx.state.is_ftl_created,
      "car-info": _ctx.state.car_info,
      "completed-cargo": _ctx.state.completed_cargo,
      "is-on-cargo-step": !_ctx.state.is_step_cargo_finished,
      onSubmit: _ctx.onCarSubmit,
      onReset: _ctx.onCarReset
    }, null, 8, ["opened", "ftl-type", "disabled", "car-info", "completed-cargo", "is-on-cargo-step", "onSubmit", "onReset"]),
    _createVNode(_component_step_waypoints, {
      class: "mt-6",
      opened: _ctx.isCompanySelected && _ctx.isDateSelected,
      completed: _ctx.state.waypoints.length > 0,
      "ftl-type": _ctx.state.ftl_type,
      "company-id": _ctx.state.company_id,
      disabled: _ctx.state.is_creating_ftl_bid || _ctx.state.is_ftl_created,
      "is-intracity": "",
      onSubmit: _ctx.onSubmitWaypoints,
      onUpdate: _ctx.onUpdateWaypoints
    }, null, 8, ["opened", "completed", "ftl-type", "company-id", "disabled", "onSubmit", "onUpdate"]),
    (_ctx.isOnCreate)
      ? (_openBlock(), _createBlock(_component_step_create, {
          key: 1,
          class: "mt-3",
          created: _ctx.state.is_ftl_created,
          loading: _ctx.state.is_creating_ftl_bid,
          disabled: !_ctx.state.waypoints.length,
          onSubmit: _ctx.onSubmitOrder,
          onNewOrder: _ctx.resetOrder
        }, null, 8, ["created", "loading", "disabled", "onSubmit", "onNewOrder"]))
      : _createCommentVNode("", true)
  ]))
}